<template>
	<div>
		<div id='address-page'>
		  <div id='cell-container'>
			<div class='cell'><div class='cell-title'>联系人</div><input type="text" v-model="consigneeName" placeholder="请填写您的姓名" placeholder-class='placeholder'/></div>
			<div class='cell'><div class='cell-title'>手机号码</div><input type="tel" v-model="consigneePhone" placeholder="请填写您的号码" placeholder-class='placeholder'/></div>
			<div class="cell" id="address" @click="open('cityPicker')">
				<div class='cell-title'>选择地区</div><div :id='city.length>0?"chosen-area":"choose-area"'>{{city.length>0?city.join(" "):"选择您的地区　〉"}}</div>
			  <!-- <mt-field label="收货地址：" :state="isValidCity ? 'success': 'error'"  v-model="showAddr" disabled></mt-field> -->
			</div>
			<div class='cell-textarea'>
				<textarea placeholder="请输入详细地址" v-model="detailAddr" rows="4"></textarea>
			</div>
		  </div>
		</div>
		<div id='save-container'><div id='save-button' @click="saveAddress">确认地址</div></div>
		<city-picker @confirm="selectCity" ref="cityPicker"></city-picker>
	</div>
</template>

<script>
import CityPicker from "@/components/CityPicker";
import { mapState, mapMutations } from "vuex";
import { getStorage, setStorage, formatNumber } from "@/utils/utils";
export default {
	components: {
	  CityPicker
	},
	data() {
		return {
		  chosenPrintPhotoSrc: null,
		  consigneeName: "",
		  consigneePhone: "",
		  detailAddr: "",
		  city: [],
			cityCode:''
		};
	},
	created() {
	  ap.setNavigationBar({
	    title: "编辑收货地址"
	  });
		this.$ba.trackPageview("/address");
	  this.initAddr();	
	},
	methods:{
		initAddr() {
		  const expressInfo = JSON.parse(getStorage("expressInfo"));
		  if (expressInfo) {
		    const { detailAddr, city, consigneeName, consigneePhone,cityCode} = expressInfo;
		    this.detailAddr = detailAddr;
		    this.consigneeName = consigneeName;
		    this.consigneePhone = consigneePhone;
		    this.city = city;
		    this.cityCode=cityCode;
		  }
		},
		open(picker) {
		  this.$refs[picker].open();
		},
		selectCity(res) {
		  this.city = res.name;
		  this.cityCode=res.code;
		},
		saveAddress(){
			if (
			  this.isValidPhone &&
			  this.isValidName &&
			  this.cityCode &&
			  this.isValidDetailAddr
			){
				const expressInfo = {
					detailAddr: this.detailAddr,
					city: this.city,
					cityCode:this.cityCode,
					consigneeName: this.consigneeName,
					consigneePhone: this.consigneePhone
				};
				setStorage("expressInfo", JSON.stringify(expressInfo));
				this.$router.go(-1);
			}else if(!this.isValidName){
        ap.showToast({
          content: "请输入姓名！"
        });
      }else if(!this.isValidPhone){
        ap.showToast({
          content: "请输入有效的手机号！"
        });
      }else if(!this.cityCode){
        ap.showToast({
          content: "请选择一个城市！"
        });
      }else if(!this.isValidDetailAddr){
        ap.showToast({
          content: "请输入详细的收货地址！"
        });
      }
    },
	},
		computed: {
			isValidPhone() {
				return /^1[34578]\d{9}$/.test(this.consigneePhone);
			},
			isValidName() {
				return this.consigneeName;
			},
			isValidCity() {
				return this.city.length > 0;
			},
			isValidDetailAddr() {
				return this.detailAddr;
			}
		}
	}

</script>

<style scoped>
#address-page{
  padding: 10px;
}
#cell-container{
  border-radius: 6px;
  width: 94.667vw;
  background:rgba(255,255,255,1);
}
.cell{
  height:55px;
  padding-left: 4.5333vw;
  padding-right: 4.5333vw;
  line-height: 55px;
  display: flex;
  align-items: center;
}
.cell-title{
  color:rgba(102,102,102,1);
  width: 17.333vw;
  display: inline-block;
}
.city-block{
  padding: 12.5px 2.5px;
  display: inline-block;
  width: 31%;
  font-size: 14px;
  height: auto;
  text-align: center;
  vertical-align: middle;
}
.city-title{
  font-size:16px;
  width: 40%;
  border-left: 5px #686868 solid;
  margin-top: 22px;
  padding-left: 5.333vw;
}
.take-place{
  height: 1px;
}
.placeholder{
  color: #999999;
  font-size: 14px;
  text-align: right;
}
#choose-area{
  width: 69.333vw;
  color: #999999;
  font-size: 14px;
  text-align: right;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
#chosen-area{
  width: 69.333vw;
  color: #333333;
  font-size: 14px;
  text-align: right;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
input{
  width: 68vw;
  text-align: right;
  line-height: 55px;
  font-size: 14px;
  color: #333333;
  position: relative;
  border: none;
}
.cell-textarea{
  height:auto;
  padding: 17px;
  /* line-height: 110rpx; */
  display: flex;
  flex-direction: row;
  align-items: baseline;
}
textarea{
  font-size: 15px;
  color: #333333;
  width: 94.667vw;
	height: auto;
  padding:0;
  display: inline-block;
	border: none;
}
#save-container{
  position: fixed;
  width:100vw;
  height:65px;
  background:rgba(255,255,255,1);
  box-shadow:0px 0px 16px 0px rgba(211,211,211,0.5);
  bottom: 0;
  padding:8.5px 2.6667vw; 

}
#save-button{
  display: inline-block;
  width: 94.667vw;
  height: 48px;
  background:rgba(68,128,231,1);
  box-shadow:0px 5px 10px 0px rgba(68,128,231,0.25);
  border-radius:24px;
  color:white;
  line-height: 48px;
  text-align: center;
  font-size: 16px;
}
</style>
